export const projectsENG = {
    "burger-builder": {
        name: "Burger Builder",
        technologyIcon: "React.svg",
        summary: "This website lets users compose and order an imagined burger.",
        discipline: ['Front-end'],
        screenshots: ['burgerBuilder1.png', 'burgerBuilder2.png', 'burgerBuilder3.png'],
        siteURL: "https://burger-builder.sarahsvedenborg.no/",
        gitHubURL: "https://github.com/sarahsvedenborg/burger-builder-from-course",
        problem: "Create an application for people to order burgers",
        demography: "Fast food consumers",
        technology: [['Framework', 'React'], ['Backend', 'Firebase'], ['Hosting', 'Netlify'], ['Internal state management', 'Redux']],
        lessons: "Firebase backend, logic for authorizing users, react router, redux, react hooks, lazy loading, project/file organization, CSS modules",
        other: "This project is created as part of a React-course taught by Maximillian Swartzmüller, on udemy.com. I have only focused on the code here. All design elements are copied directly from the course. See retro-burger-builder for my own redesign of the project.",
        acknowledgements: [{what: 'React course by Maximillian Swartzmüller', source: 'https://udemy.com'}]
    },
    "for-barna": {
        name: "ForBarna.no",
        technologyIcon: "Vue.svg",
        summary: "A website which contains all the pedagogical games I make for my children.",
        discipline: ['UX', 'Front-end'],
        screenshots: ['forBarna1.png', 'forBarna2.png', 'forBarna3.png'],
        siteURL: "https://www.forbarna.no",
        gitHubURL: "https://github.com/sarahsvedenborg/forbarna",
        problem: "I need a website which can contain all the pedagogical games we make for our children.",
        demography: "Children, aged 6-9.",
        technology: [['Framework', 'Vue.js'], ['Backend', 'Firebase (Not yet implemented)'], ['Hosting', 'Netlify'], ['Version control', 'Git'], ['Project planning', 'Trello']],
        lessons: "Responsive design, iPad first, drag and drop on iPad, information hierarchy, CSS animations",
        other: "",
        acknowledgements: []
    },
    "portfolio": {
        name: "sarahsvedenborg.no",
        technologyIcon: "Vue.svg",
        summary: "This is the website you are currently visiting: Developed by myself, for myself. ",
        discipline: ['UX', 'Front-end'],
        screenshots: ['portfolio1.png', 'portfolio2.png', 'portfolio3.png'],
        siteURL: "https://www.sarahsvedenborg.no",
        gitHubURL: "https://github.com/sarahsvedenborg/portfolio/tree/master",
        problem: "Create a portfolio to showcase who I am and what I can do",
        demography: "Other like-minded people",
        technology: [['Framework', 'Vue.js'], ['Hosting', 'Netlify'], ['UI design', 'Sketch']],
        lessons: "Lasy-loading, single file components, VUE Router, i18n, custom responsive grid, custom UI components, CSS animations, folder structure, responsive design, CSS structure",
        other: "",
        acknowledgements: [{what: 'Custom responsive grid', source: 'https://medium.com/csun-metalab/creating-a-simple-mobile-first-grid-system-1e883a85fa3f'}]
    },
    "beauty-board": {
        wip: true,
        name: "Beauty Board",
        technologyIcon: "React.svg",
        summary: "This is a To Do application based on Trello. ",
        discipline: ['UX', 'Front-end'],
        screenshots: ['myBoard1.png'],
        siteURL: "",
        gitHubURL: "",
        problem: "Implement Trello-ish app from scratch",
        demography: "Project planners, individuals who want to keep track of their To-Dos",
        technology: [['Framework', 'React'], ['Backend', 'Firebase'], ['Hosting', '?'], ['State management', 'Redux']],
        lessons: "Virtual list for backup, drag and drop, redux, react-router, react hooks,",
        other: "I have made this application from scratch.",
        acknowledgements: [{what: 'Type of app', source: 'https://www.trello.com'}, {what: 'Drag and drop', source: 'https://github.com/atlassian/react-beautiful-dnd'}]
    },
    "retro-burger-builder": {
        wip: true,
        name: "Retro Burger Builder",
        technologyIcon: "React.svg",
        summary: "Redesign of the Burger Builder app. The design and user experience is changed.",
        discipline: ['UX'],
        screenshots: ['retro1.png', 'retro2.png', 'retro3.png'],
        siteURL: "",
        gitHubURL: "",
        problem: "Create an interface for people to order burgers",
        demography: "Fast food consumers",
        technology: [['Framework', 'React'], ['Backend', 'Firebase'], ['Hosting', 'Netlify'], ['Internal state management', 'Redux'], ['UI design', 'Sketch']],
        lessons: "Creating a new design based on a poster, improving navigation structure, more experience with Sketch, responsive assets",
        other: "The front-end code is based on the Burger Builder project (which is part of a React course taught on udemy.com by Maximillian Swartzmüller). In this specific project, I have redesigned the interface to provide a more popping impression and a smoother user experience.",
        acknowledgements: [{what: 'Poster for inspiration', source:"https://www.uidownload.com/free-vectors/retro-burger-menu-436692"}]
    }

}